import { useTranslations } from 'next-intl'

import { TSimpleReviewCount } from '@/entities/room'
import { Separator } from '@/shared/ui'

import { SubHeading } from '../../common'

type Props = {
  hostSimpleReview: TSimpleReviewCount[]
}

export const MobileReview = ({ hostSimpleReview }: Props) => {
  const t = useTranslations('room_detail')

  const hasReview = hostSimpleReview.length > 0

  if (!hasReview) {
    return null
  }

  return (
    <>
      <Separator color="light-gray" className="md:hidden" />
      <div className="space-y-3 px-5 py-6 md:p-0">
        <SubHeading className="typo-body2">
          {t('landlord_profile.landlord_review')}
        </SubHeading>
        <ul className="flex gap-3 md:flex-col md:gap-2">
          {hostSimpleReview.slice(0, 2).map(review => (
            <li key={review.simpleReviewTemplateId} className="flex-1">
              <div className="bg-gray-0 flex items-center justify-between rounded-sm p-4">
                <span className="typo-label1 font-normal text-gray-900">
                  {review.content}
                </span>
                <span className="typo-body2 font-semibold text-black">
                  {review.count}
                </span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </>
  )
}
